module.exports = __webpack_public_path__ + "img/wave.7cb0eecf.svg";